import { ICustomerConfidenceLevel } from '../../../interfaces/CaseDetail.type';

export const convertToRadioOptions = (telephoneCustomerConfidence: ICustomerConfidenceLevel[]) => {
  return telephoneCustomerConfidence.map((item, index) => ({
    id: (index + 1).toString(),
    value: item.name,
    label: `${item.label} (${item.level})`,
    otherProps: {
      label: item.label,
      level: item.level,
      name: item.name
    }
  }));
};
